
import Tab from './tab'

const isPane  = ({ tag }) => tag && tag.endsWith('VsTabPane')

export default {
  name: 'VsTabs',
  components: {
    Tab
  },
  props: {
    value: {
      type: String,
      default: null
    },
    stretch: {
      type: Boolean,
      default: false
    }
  },
  vessel: {
    tabs: {
      position: 'relative',
      borderBottomWidth: '2',
      borderColor: 'grey-lighter'
    },
    bar: {
      backgroundColor: 'primary'
    }
  },
  watch: {
    value(value) {
      if (value != this.active) {
        this.active = value
      }
    },
    active(value) {
      this.activateTab(value)
      this.updateBar()
      this.setPosition()
    }
  },
  data() {
    return {
      tabs: [],
      active: this.value,
      barStyle: null
    }
  },
  methods: {
    activateTab(name) {
      if (!this.$slots.default) return

      this.$slots.__active__ = this.$slots.default.filter(isPane).find(
        ({ componentOptions }) => componentOptions.propsData.name == name
      )
    },
    updateTabs() {
      if (this.$slots.__active__ || !this.$slots.default) return

      const tabs = this.$slots.default.filter(isPane).map(({ componentOptions }) => ({
        ...componentOptions.propsData
      }))

      if (!this.active && tabs.length) {
        this.active = tabs[0].name
      }

      this.tabs = tabs
      this.activateTab(this.active)
    },
    updateBar() {
      const active = this.$refs.tabs.find(({ name }) => name == this.active)
      if (!active) return

      const { offsetWidth, offsetLeft } = active.$el

      this.barStyle = {
        width: `${offsetWidth}px`,
        transform: `translateX(${offsetLeft}px)`
      }
    },
    setPosition() {
      const active = this.$refs.tabs.find(({ name }) => name == this.active)
      if (!active) return

      const item = active.$el
      const next = item.nextElementSibling
      const size = this.$refs.scroller.offsetWidth

      let scroll = size - item.offsetLeft - item.offsetWidth

      if (next) {
        scroll = scroll - (next.offsetWidth || 0)
      }

      if (scroll > -10) {
        scroll = 0
      }

      this.$refs.scroller.scrollLeft = Math.abs(scroll)
    },
    isActive(tab) {
      return tab.name == this.active
    },
    onClick(tab) {
      this.active = tab.name

      this.$emit('input', tab.name)
      this.$emit('tab-click', tab)
    }
  },
  created() {
    this.updateTabs()
  },
  mounted() {
    this.updateBar()
  },
  updated() {
    this.updateTabs()
  }
}
